import convertPropNames from 'src/infrastructure/caseConverter'
import http, { Response } from 'src/infrastructure/http'
import { Product } from '../types'
import { GetStockProducts } from './StockListTypes'

const getStockProducts = async ({
  fulfillmentCenterId,
  modelId,
  code,
  barcode,
  page,
  pageSize,
  description,
}: GetStockProducts) => {
  const result = await http.get('v2/stock/products', {
    params: {
      fulfillment_center_id: fulfillmentCenterId,
      model_id: modelId,
      code: code || undefined,
      barcode: barcode || undefined,
      description: description || undefined,
      page,
      page_size: pageSize,
    },
  })

  return convertPropNames<Response<Product[]>>(result.data)
}

export default {
  getStockProducts,
}
